<!--
ダミー画面
URL：未作成の画面を表示する
-->

<template><div></div></template>

<script>
export default {};
</script>

<style></style>
